import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SeverityBadge } from "@/components/Primitives";
import { Repeat, Hammer } from "lucide-react";
import { toast } from "sonner";

export default function Recurring() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/recurring-issues").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const detect = async () => {
    const { data } = await api.post("/recurring-issues/detect");
    toast.success(`Detection complete · ₱{data.detected} patterns`);
    load();
  };
  const convert = async (id) => {
    await api.post(`/recurring-issues/${id}/convert-to-problem`);
    toast.success("Converted to Problem Record");
    load();
  };
  const total = items.reduce((a,c) => a + (c.estimated_cost_php || 0), 0);
  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Recurring Issue Intelligence</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Detected Patterns ({items.length})</h1>
          <div className="text-xs text-emerald-400 font-mono mt-1">Estimated support cost leakage · ₱{total.toLocaleString()}</div>
        </div>
        <button onClick={detect} data-testid="recurring-detect-btn" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md px-3 py-2"><Repeat size={14}/> Re-run detection</button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {items.length === 0 && <div className="text-zinc-500 text-sm">No recurring patterns yet — click &ldquo;Re-run detection&rdquo;.</div>}
        {items.map(r => (
          <div key={r.id} className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
            <div className="flex items-center gap-2 mb-2">
              <SeverityBadge level={r.severity} />
              <div className="text-sm font-mono text-zinc-400">{r.category}</div>
              <div className="ml-auto text-emerald-400 font-mono text-sm">₱{r.estimated_cost_php.toLocaleString()}</div>
            </div>
            <h2 className="font-display text-lg tracking-tight">Same asset · {r.occurrences} occurrences</h2>
            <div className="text-[11px] text-zinc-500 font-mono mt-1">First {r.first_seen?.slice(0,10)} → Last {r.last_seen?.slice(0,10)} · SLA impact: {r.sla_impact}</div>
            <div className="mt-3 grid grid-cols-2 gap-3">
              <div><div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Suggested Root Cause</div><div className="text-xs text-zinc-300 mt-1">{r.suggested_root_cause}</div></div>
              <div><div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Suggested Fix</div><div className="text-xs text-zinc-300 mt-1">{r.suggested_fix}</div></div>
            </div>
            <div className="mt-4 flex gap-2">
              <button onClick={()=>convert(r.id)} data-testid={`recurring-convert-${r.id}`} className="text-xs inline-flex items-center gap-1 bg-amber-500/20 text-amber-300 border border-amber-500/30 rounded px-3 py-1.5"><Hammer size={12}/> Convert to Problem</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
